import { EchoFilter, EchoFilterRequest } from '../filter/types';

export enum SCHEDULE_COACHING_VISIBILITY_MODE {
    OWNER_ONLY = 'OwnerOnly',
    ALL_AUTHORIZED_USERS = 'AllAuthorizedUsers',
}

export type IScheduleCoachJobInterval = {
    startDate: string;
    endDate: string | null;
    rRule: string;
};

export type IScheduledCoachJob = {
    id: string;
    title: string;
    description: string;
    visibilityMode: SCHEDULE_COACHING_VISIBILITY_MODE; // change
    totalCoachingOccasions: number; // change
    interactionsPerRun: number;
    formId: string;
    createdByUserId: string;
    createdByUsername: string;
    createdAt: string;
    /**
     * Whether the signed-in user may edit or delete this schedule.
     * Decided by the backend, never re-derived here.
     */
    canManage: boolean;
    filter: EchoFilter;
    intervals: IScheduleCoachJobInterval[];
};

export type RequestPostScheduleCoachJob = Pick<
    IScheduledCoachJob,
    | 'title'
    | 'formId'
    | 'description'
    | 'interactionsPerRun'
    | 'visibilityMode'
    | 'totalCoachingOccasions'
    | 'intervals'
> & {
    filter: EchoFilterRequest;
};

export type ResponseGetScheduledCoachJobs = { scheduledCoachJobs: IScheduledCoachJob[] };

export type RequestPutScheduleCoachJob = {
    coachJobId: string;
} & Partial<RequestPostScheduleCoachJob>;

export type RequestDeleteScheduleCoachJob = {
    coachJobId: string;
};
